// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"0afd8016","294":"f9fc6ef7","375":"80e772ae","457":"22788fec","551":"24873568","672":"9654b532","842":"79ac3728","869":"1cc36532"}[chunkId] + ".chunk.js";
};